/**
 * Ensures at most one in-flight token exchange per OAuth authorization `code`.
 * Okta authorization codes are single-use; a duplicate POST returns `invalid_grant`.
 */
const exchangeByCode = new Map<string, Promise<void>>();

export function runAuthorizationCodeExchangeOnce(
  code: string,
  run: () => Promise<void>,
): Promise<void> {
  const existing = exchangeByCode.get(code);
  if (existing) {
    return existing;
  }
  const promise = run().finally(() => {
    exchangeByCode.delete(code);
  });
  exchangeByCode.set(code, promise);
  return promise;
}
